
import gtm from '@/mixins/gtm'
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import { head } from '@/utils/head'
import { getPageBySlug } from '@/services/fetch/modules/cms'

export default {
  mixins: [gtm],

  data() {
    return {
      gtmSubsection2: 'PaymentsPolicy',
      document: {},
      isAwaitingResponse: true,
    }
  },

  fetchKey: 'internal',

  async fetch() {
    const locale = this.$i18n.locale
    this.document = await getPageBySlug(locale, 'payments-policy')
    this.isAwaitingResponse = false
  },

  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es', 'fr', 'ja', 'it', 'de', 'nl'],
  },

  head() {
    if (!this.isAwaitingResponse && this.document[0]) {
      const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
      let title = this.document[0].hero.title
      const description = this.$t('seo.shared.descriptionTemplate', { description: title })
      const url = `${process.env.BASE_URL}${this.$route.path}`
      const canonical = url

      return head({
        title,
        description,
        url,
        canonical,
        htmlAttrs: { ...i18nHead.htmlAttrs },
        link: SEO.linkAlternate.setList(this.$route.name),
        breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
      })
    }
  },
  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },
}
